// Google Reviews data — pulled from Google My Business
// To update: edit text + add new entries when more reviews come in.
// Order: most impactful first (oncology patients, professionals, transformative testimonials).
export const GOOGLE_REVIEWS = [
  {
    name: "Montse Marzo Castillejo",
    rating: 5,
    text:
      "La Marta, con su voz tan dulce y su generosidad, es un regalo. Sus meditaciones me han acompañado en mi proceso oncológico, aportándome paz, confianza y aceptación. Me han enseñado que lo más importante es vivir el presente.",
  },
  {
    name: "Montse Fita",
    rating: 5,
    text:
      "Las sesiones de yoga oncológico con Marta están siendo una experiencia buenísima. La sensibilidad de Marta nos ayuda a ver este tiempo de tratamiento con otros ojos. De una forma muy relajada podemos seguir haciendo nuestra vida.",
  },
  {
    name: "neuroup",
    role: "Neuropsicóloga",
    rating: 5,
    text:
      "Como neuropsicóloga, valoro profundamente el enfoque de Marta. El yoga oncológico requiere una sensibilidad y una formación técnica muy específica que domina a la perfección. Su capacidad para adaptar la práctica a las necesidades de cada persona es excepcional.",
  },
  {
    name: "JM Badia Roig",
    rating: 5,
    text:
      "Conocí a Marta como profesora de clases de yoga restaurativo en Silencio Barcelona. Todas sus sesiones son siempre acogedoras, instructivas y muy profesionales. A lo largo de cada clase, en ningún momento deja de estar pendiente de ti y apoyarte. Es un diez. La recomiendo.",
  },
  {
    name: "Clarena Ariza",
    rating: 5,
    text:
      "Marta es una persona con una infinita sensibilidad y una gran profesional. A través de su propia experiencia ha querido aprender, investigar y transmitir en cada una de sus clases de yoga la importancia y cuidado que cada persona necesita.",
  },
  {
    name: "Consu G.",
    role: "Local Guide · Google",
    rating: 5,
    text:
      "Gran profesional que se adapta a todos los casos y situaciones, te ayuda a mejorar tu vida diaria. Me siento muy a gusto y realizada haciendo sus técnicas. Transmite mucha energía positiva. Un ejemplo de persona para todas.",
  },
  {
    name: "AvanZa Retail",
    rating: 5,
    text:
      "Marta te da paz. Cuando tienes miedo, conseguir un equilibrio emocional, físico y mental es algo… uahuuuu.",
  },
];

export const GOOGLE_REVIEWS_TOTAL = 7;
export const GOOGLE_REVIEWS_RATING = "5,0";

// Replace with the direct Google reviews link (g.page/r/...) when available.
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=M%C3%A9todo+TAO+by+Marta+Montardit#lrd=";
